import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getActions } from '@/features/patient-actions/apis/patientActionsApi'
import { Action } from '@/features/patient-actions/types/patientActions'

/**
 * 患者のアクションのみを取得するクエリ
 *
 * @param patientId - 患者ID（null の場合はスキップ）
 * @returns TanStack Query result with data: Action[]
 */
export const usePatientActionsQuery = (patientId: string | null) => {
  return useQuery({
    queryKey: queryKeys.patientActions.forPatient(patientId ?? ''),
    queryFn: async (): Promise<Action[]> => {
      if (!patientId) {
        return []
      }
      const response = await getActions({ patient: patientId })
      return response.results || []
    },
    enabled: !!patientId,
    staleTime: 1000 * 60 * 2, // 2分キャッシュ
  })
}
